
import createHistory from 'history/createBrowserHistory';

export const history = createHistory();



// WEBPACK FOOTER //
// src/history.js